import { useState, forwardRef, useImperativeHandle } from "react";
import PlutoFrame from "./PlutoFrame";
import ViewerHeader from "./ViewerHeader";
import BrowserInspector from "./BrowserInspector";

export interface ViewerRef {
  setSelectedTab: (tab: "Preview" | "Browser Inspector") => void;
  getSelectedTab: () => "Preview" | "Browser Inspector";
}

const Viewer = forwardRef<
  ViewerRef,
  {
    lastChangeHadSpace: boolean;
    code: string;
    onRun: () => void;
    onRefresh: () => void;
  }
>(({ lastChangeHadSpace, code, onRun, onRefresh }, ref) => {
  const [selectedTab, setSelectedTab] = useState<
    "Preview" | "Browser Inspector"
  >("Preview");

  useImperativeHandle(ref, () => ({
    setSelectedTab,
    getSelectedTab: () => selectedTab,
  }));

  return (
    <div className="w-full h-full rounded-2xl border border-gray-100 overflow-hidden flex flex-col">
      <ViewerHeader
        onRun={onRun}
        onRefresh={onRefresh}
        onTabChange={setSelectedTab}
        selectedTab={selectedTab}
      />

      <div
        className="w-full flex-1"
        style={{
          backgroundImage:
            "radial-gradient(circle 2px at 2px 2px, #ccc 100%,  #f5f5f5 0)",
          backgroundSize: "40px 40px",
          backgroundPosition: "-4px 20px",
        }}
      >
        <div
          className={`${selectedTab === "Preview" ? "block" : "hidden"} w-full h-full flex justify-center items-center`}
        >
          <PlutoFrame
            // This is a lil hack to trigger a refresh on every save.
            code={lastChangeHadSpace ? `${code} ` : code}
            onProof={console.log}
            onError={console.error}
          />
        </div>
        <div
          className={`${selectedTab === "Browser Inspector" ? "block" : "hidden"} w-full h-full`}
        >
          <BrowserInspector
            refresh={!!lastChangeHadSpace}
            onComplete={() => {
              setSelectedTab("Preview");
            }}
          />
        </div>
      </div>
    </div>
  );
});

export default Viewer;
